import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { AssignedOrganisation, EditOrganisationDto, Organisation, OrganisationDTO, OrganisationDetails, OrganisationValidationDTO, UpdateOrganisationTableDto } from "../_models/Organisation";
import { OrganisationRecord } from "../_models/OrganisationRecord";
import { AppConstants } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class OrganisationService {
  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "Organisation/";
  private static readonly UPDATEORGANISATIONLIST_URI: string = "updateorganisationlist";
  private static readonly DISPLAYORGLIST_URI: string = "displayorganisationlist";
  private static readonly RESETORGLIST_URI: string = "resetorganisationlist";
  private static readonly GETORGLISTLENGTH_URI: string = "organisationlistlength";
  private static readonly ISVALIDORGNAME: string = "isvalidorgname";
  private static readonly GETORGDETAILS_URI: string = "getorganisationdetails";
  private static readonly GET_ASSIGNED_ORGANISATION: string = "getassignedorganisations";
  private static readonly VALIDATE_DELETE_ORGANISATION: string = "validatedelete";

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  public getOrganisations$(): Observable<Organisation[]> {
    return this.http.get<Organisation[]>(
      this.baseUrl + OrganisationService.path
    );
  }

  public updateOrganisationTableRecords$(updateDto: UpdateOrganisationTableDto): Observable<boolean> {
    return this.http.put<boolean>(this.baseUrl + OrganisationService.path + OrganisationService.UPDATEORGANISATIONLIST_URI, updateDto);
  }

  public getOrganisationTableRecord$(pageNumber: number, isInitialLoad: boolean): Observable<OrganisationRecord[]> {
    let params = new HttpParams().set("pageNumber", String(+pageNumber + 1));
    if(isInitialLoad)
    params = params.set("isInitialLoad", String(isInitialLoad));

    return this.http.get<OrganisationRecord[]>(this.baseUrl + OrganisationService.path + OrganisationService.DISPLAYORGLIST_URI, { params });
  }

  public resetOrganisationTable$(): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + OrganisationService.path + OrganisationService.RESETORGLIST_URI);
  }

  public getOrganisationTableLength$(): Observable<number> {
    return this.http.get<number>(this.baseUrl + OrganisationService.path + OrganisationService.GETORGLISTLENGTH_URI);
  }

  public createOrganisation$(organisationDto: OrganisationDTO): Observable<Organisation> {
    return this.http.post<Organisation>(this.baseUrl + OrganisationService.path, organisationDto);
  }

  public isValidOrganisationName$(orgValidationDto: OrganisationValidationDTO): Observable<boolean | string> {
    return this.http.post<boolean | string>(this.baseUrl + OrganisationService.path + OrganisationService.ISVALIDORGNAME, orgValidationDto);
  }

  public getOrganisationDetails$(orgId: number): Observable<OrganisationDetails> {
    return this.http.get<OrganisationDetails>(this.baseUrl + OrganisationService.path + OrganisationService.GETORGDETAILS_URI + "/" + orgId);
  }

  public editOrganisation$(editOrg: EditOrganisationDto): Observable<Organisation> {
    return this.http.put<Organisation>(this.baseUrl + OrganisationService.path + editOrg.id, editOrg);
  }

  public getAssignedOrganisation$(): Observable<AssignedOrganisation[]> {
    return this.http.get<AssignedOrganisation[]>(
      `${this.baseUrl}${OrganisationService.path}${OrganisationService.GET_ASSIGNED_ORGANISATION}`
    );
  }

  public validateDelete$(orgId: number): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.baseUrl}${OrganisationService.path}${OrganisationService.VALIDATE_DELETE_ORGANISATION}${AppConstants.SLASH}${orgId}`
    );
  }

  public deleteOrganisation$(orgId: number): Observable<boolean> {
    return this.http.delete<boolean>(
      `${this.baseUrl}${OrganisationService.path}${orgId}`
    );
  }
}
